import React, {useEffect, useState} from "react";
import {getUserWorks, removeUserWorkById} from "../../service";
import {getUserStorage} from "../../units";
import Empty from "../../components/empty";
import {Link, useHistory} from "react-router-dom";
import { WorksData } from "../types";
import {useLoading} from "../../components/loading/LoadingProvider";
import useRefresh from "../../routers/useRefresh";
import useUserInfo from "../../routers/useUserInfo";

function Works(){

    const [lists,setLists] = useState<Array<WorksData>>([])
    const userData = useUserInfo()
    const { current } = useRefresh()
    const his = useHistory()

    useEffect(() => {
        if(userData){
            getUserWorks({
                userId:userData.id
            }).then(res => {
                if(res.code === 1){
                    setLists(res.data)
                }
            })
        }

    },[current])

    const DetailHandle = (id:string) => {
        his.push(`/user/info/works/${ id }/modify`)
    }



    return <div className="job-detail education">
        <div className="wrapper">
            <div className="flex">
                <h1>工作经历</h1>
                <Link to={ '/user/info/works/add' } className="common-more iconfont">&#xe609;</Link>
            </div>
            <div className="lists">
                {
                   lists.length > 0 ?  lists.map((item,index) => {
                       return <div className="item" key={index} onClick={ () =>  DetailHandle(item.id)}>
                           <div className="flex">
                               <h2>{ item.company }</h2>
                               <p className="iconfont" style={{ opacity:.65 }}>&#xe608;</p>
                           </div>
                           <p className="d">{ item.start.replace(/-/g,'.') } - { item.end.replace(/-/g,'.') } · { item.post }</p>
                           <p className="x">工作内容：{ item.content }</p>
                       </div>
                   }) : <Empty>
                       暂无工作经历
                   </Empty>
                }
            </div>
        </div>
    </div>
}

export default  Works
